import { render } from "./ItemListView.vue?vue&type=template&id=5bef425a&scoped=true&ts=true"
import script from "./ItemListView.vue?vue&type=script&lang=ts"
export * from "./ItemListView.vue?vue&type=script&lang=ts"

import "./ItemListView.vue?vue&type=style&index=0&id=5bef425a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bef425a"]])

export default __exports__